/** Missed SSE heartbeats (server default 5s) before treating the stream as dead. */
export const STREAM_STALL_MS = 25_000

/**
 * Abort a chat SSE read that stopped receiving chunks (API restart, half-open
 * TCP). Heartbeats count as activity, so a live LLM wait must not trip this.
 */
export function createStreamStallWatchdog(opts: {
  stallMs?: number
  onStall: () => void
}): {
  bump: () => void
  clear: () => void
  isStalled: () => boolean
} {
  const stallMs = opts.stallMs ?? STREAM_STALL_MS
  let timer: ReturnType<typeof setTimeout> | null = null
  let stalled = false

  const clear = () => {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }

  const bump = () => {
    if (stalled) return
    clear()
    timer = setTimeout(() => {
      stalled = true
      opts.onStall()
    }, stallMs)
  }

  bump()
  return {
    bump,
    clear,
    isStalled: () => stalled,
  }
}
